import { makeStyles } from '@material-ui/core/styles';
import get from 'lodash/get';

export default makeStyles(theme => ({
  logo: {
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(0, 12),
    },
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(0, 8),
    },
    margin: theme.spacing(0, 4),
  },
  root: {
    background: ({ transparent }) => (
      transparent ? 'transparent' : '#fff'
    ),
    boxShadow: ({ transparent }) => (
      transparent
        ? 'none'
        : '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'
    ),
    display: 'flex',
    flex: 1,
  },
  section: {
    alignItems: 'center',
    borderRadius: 8,
    display: 'flex',
    margin: theme.spacing(0, 1),
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(0, 2),
    },
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: ({ heights }) => get(heights, 'main', 100),
  },
  topHeader: {
    alignItems: 'center',
    background: theme.palette.primary.dark,
    color: theme.palette.white,
    display: 'flex',
    height: ({ heights }) => get(heights, 'top', 32),
    justifyContent: 'space-around',
    width: '100%',
  },
  topHeaderItem: {
    alignItems: 'center',
    color: '#fff',
    display: 'flex',
  },
  topHeaderItemImg: {
    marginRight: theme.spacing(1),
    marginTop: -1,
  },
}));
